module.exports = __webpack_public_path__ + "img/dump-station.2f0db638.svg";